import { render, staticRenderFns } from "./VirtualAccounts.vue?vue&type=template&id=7afc314c&scoped=true&"
import script from "./VirtualAccounts.vue?vue&type=script&lang=js&"
export * from "./VirtualAccounts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7afc314c",
  null
  
)

export default component.exports